document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.schema-faq-section');

	sections.forEach(section => {
		const question = section.querySelector('.schema-faq-question');
		const answer = section.querySelector('.schema-faq-answer');

		if (!question || !answer) return;

		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'schema-faq-toggle';
		button.setAttribute('aria-expanded', 'false');
		button.setAttribute('aria-controls', `${section.id}-answer`);
		button.textContent = question.textContent;

		answer.id = `${section.id}-answer`;
		answer.hidden = true;

		question.replaceWith(button);

		button.addEventListener('click', () => {
			const isOpen = button.getAttribute('aria-expanded') === 'true';
			button.setAttribute('aria-expanded', String(!isOpen));
			answer.hidden = isOpen;
			section.classList.toggle('is-open', !isOpen);
		});
	});
});
